<div class="cipo--width--full" fxLayout="column">
    <mat-dialog-content fxFlex="grow" class="m-x-lg m-b-lg">
        <div fxFlex="grow" class="p-x-xl cipo-bg--white cipo--overflow--auto">
            @if (!currentCategoryGroup()) {
                <app-data-list-command
                    [hidefilter]="true"
                    (filtersToApplyChange)="search($event)"
                    sidenavclass="p-y-3xl">
                    <div fxLayout fxLayoutAlign="space-between center">
                        <button
                            mat-raised-button
                            color="primary"
                            data-testid="lists-action-addnew"
                            (click)="addNewCategoryGroup()"
                            [disabled]="isLoading()">
                            <mat-icon class="material-symbols-outlined">format_list_bulleted_add</mat-icon>
                            {{ "general.table.addNew" | translate }}
                        </button>
                    </div>
                    <cipo-paged-data-list
                        [tableColumns]="tableColumns"
                        [loading]="isLoading()"
                        [tableData]="tableData()"
                        class="data-list"
                        [options]="tableOptions()"
                        (sortChanged)="handleSort($event)"
                        (paginationUpdated)="handlePagination($event)"
                        (rowClicked)="currentCategoryGroup.set($event)"
                        (actionSelected)="handleAction($any($event))" />
                </app-data-list-command>
            } @else {
                <cipo-category-group-view
                    [(categoryGroup)]="currentCategoryGroup"
                    [(anythingChanged)]="anythingChanged"
                    (backToDataList)="returnFromCategoryGroupView()" />
            }
        </div>
    </mat-dialog-content>
    <div fxLayoutAlign="end center" class="cipo--width--full p-a-sm" [class.cipo-bg--warning]="anythingChanged()">
        <button class="m-r-md" mat-button (click)="onCloseClick()" [disabled]="isLoading()">
            {{ "general.cancel" | translate }}
        </button>
        @if (anythingChanged()) {
            <button class="m-r-md" mat-button (click)="discardChanges()" [disabled]="isLoading()">
                {{ "general.discard" | translate }}
            </button>
            <button mat-raised-button color="primary" [disabled]="isLoading()" (click)="saveCategoryGroup()">
                {{ "general.save" | translate }}
            </button>
        }
    </div>
</div>
